import React from 'react';
import { gql, useQuery } from '@apollo/client';
import { AssessmentSessionNotificationsList } from '../AssessmentSessionNotificationsList/assessment-session-notifications-list.component';

const GET_COMPLETED_NOTIFICATIONS = gql`
  query GetAssessmentSessionCompletedNotifications($_id: ID!) {
    assessmentSession(_id: $_id) {
      _id
      completedNotifications {
        sentAt
        scheduledAt
        type
      }
    }
  }
`;

interface IAssessmentSessionCompletedNotificationsGraphQL {
  assessmentSessionId: string;
}

export const AssessmentSessionCompletedNotificationsGraphQL: React.FC<IAssessmentSessionCompletedNotificationsGraphQL> = ({ assessmentSessionId }) => {
  const { data } = useQuery(GET_COMPLETED_NOTIFICATIONS, {
    variables: { _id: assessmentSessionId },
    fetchPolicy: 'cache-and-network'
  });

  const notifications = data?.assessmentSession && data.assessmentSession.completedNotifications;

  return <AssessmentSessionNotificationsList notifications={notifications} />
};
